import React from 'react'
import { Select, Input, Button, Tabs, Spin, Pagination, DatePicker } from 'antd'
import {ajaxApi} from '@/server/index'
import {getCookieNew} from '@/public/utils'
import moment from 'moment'
import 'moment/locale/zh-cn'
import _lodash from 'lodash'
import common from '@/public/common'
import styles from './commodity-management-list.module.less'
import './index.less'
import TableComponent from './tablecomponent'
const Option = Select.Option
const TabPane = Tabs.TabPane
const { RangePicker } = DatePicker
class CommodityManagementList extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      spinLoading: false,
      tableData: [],
      total: 0,
      opration: false,
      paramData: {
        's_code': getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null,
        'name': '',
        'brand_id': null,
        'category_id': null,
        'import_part': '',
        'status': '',
        'import_result': '',
        'begin_time': null,
        'end_time': null,
        'page_size': 10,
        'page_index': 0
      },
      brandArr: [], // 品牌
      categoryArr: [], // 类别
      importPartArr: [
        {
          name: '初审',
          value: 'first'
        },
        {
          name: '复审',
          value: 'second'
        }
      ],
      statusArr: [
        {
          name: '待提交',
          value: 'to_submit'
        },
        {
          name: '待审核',
          value: 'to_check'
        },
        {
          name: '审核中',
          value: 'on_check'
        },
        {
          name: '审核通过',
          value: 'pass_check'
        },
        {
          name: '审核拒绝',
          value: 'refuse_check'
        },
        {
          name: '返回修改',
          value: 'to_edit'
        },
        {
          name: '已关闭',
          value: 'closed'
        },
        {
          name: '待补充',
          value: 'to_complete'
        }
      ],
      is_completeArr: [
        {
          name: '是',
          value: 1
        },
        {
          name: '否',
          value: 0
        }
      ],
      momentDataStart: null,
      momentDataEnd: null
    }
  }

  componentDidMount () {
    this.getQueryBrand()
    this.getQueryCategory()
    this.getTableData()
    document.addEventListener('keydown', this.onKeyup)
  }

  // 获取类表数据
  getTableData = async () => {
    let {tableData, paramData} = this.state
    try {
      this.setState({
        spinLoading: true
      })
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-list',
        params: paramData
      })
      this.setState({
        spinLoading: false
      })
      if (res.status === 200 && res.data) {
        if (res.data.data.length !== 0) {
          _lodash.forEach(res.data.data, (item, index) => {
            item.key = index
          })
          this.setState({
            tableData: res.data.data,
            total: res.data.total
          })
        } else {
          this.setState({
            tableData: [],
            total: 0
          })
        }
      } else {
        this.setState({
          tableData: [],
          total: 0
        })
      }
    } catch (e) {
      this.setState({
        spinLoading: false
      })
      // console.log(e)
    }
  }

   // 回车事件
   onKeyup = (e) => {
     if (e.charCode === 13 || e.keyCode === 13) {
       this.handleSearch()
     }
   }

  // 查询品牌
  getQueryBrand = async () => {
    let {brandArr} = this.state
    try {
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-brand',
        params: {}
      })
      if (res.status === 200 && res.data) {
        this.setState({
          brandArr: res.data.data
        })
      } else {
        this.setState({
          brandArr: []
        })
      }
    } catch (e) {
      // console.log(e)
    }
  }

  // 获取时间的值
  handleChangeDate = (e, name) => {
    let {paramData} = this.state
    if (name === 'begin_time') {
      paramData[name] = new Date(moment(e).format('YYYY-MM-DD 00:00:00')).getTime()
      this.setState({
        momentDataStart: e
      })
    } else {
      paramData[name] = new Date(moment(e).format('YYYY-MM-DD 23:59:59')).getTime()
      this.setState({
        momentDataEnd: e ? moment(moment(e).format('YYYY-MM-DD'), 'YYYY-MM-DD') : null
      })
    }
    this.setState({
      paramData
    })
  }

    // 查询类别（商品中心下拉选项，返回 category_option_list，old_category_code 为老 id）
    getQueryCategory = async () => {
      try {
        let res = await ajaxApi({
          url: common.mdmUrl + 'product/list/select-option',
          params: {
            operator_id: getCookieNew('accountId') || '10',
            operator_name: getCookieNew('supplier_company_name') || 'SCS系统'
          }
        })
        if (res.status === 200 && res.data && res.data.data) {
          this.setState({
            categoryArr: res.data.data.category_option_list || []
          })
        } else {
          this.setState({
            categoryArr: []
          })
        }
      } catch (e) {
        this.setState({
          categoryArr: []
        })
      }
    }

    // 获取下拉框的值
    handelChangeSource=(e, name) => {
      let {paramData} = this.state
      paramData[name] = e
      this.setState({
        paramData
      }, () => {
      })
    }

    // 获取输入框的值
    handleChangeInput=(e, name) => {
      let {paramData} = this.state
      paramData[name] = e.target.value
      this.setState({
        paramData
      })
    }

    // 查询
    handleSearch=() => {
      let {paramData} = this.state
      paramData.page_index = 0
      this.setState({
        paramData,
        opration: true
      }, () => {
        this.getTableData()
      })
    }

    // 分页
    pageChage = (page, pageSize) => {
      let { paramData } = this.state
      paramData.page_index = page - 1
      paramData.page_size = pageSize
      this.setState({
        paramData,
        opration: true
      }, () => {
        this.getTableData()
      })
    }

    // 页数据修改
  onShowSizeChange = (current, pageSize) => {
    try {
      let { paramData } = this.state
      paramData.page_size = pageSize
      paramData.page_index = current - 1
      this.setState({
        paramData,
        opration: true
      }, () => {
        this.getTableData()
      })
    } catch (error) {
      console.log(error)
    }
  }

    // 重置
    handleReset=() => {
      let {paramData} = this.state
      paramData.sid = getCookieNew('sid') || null
      paramData.brand_id = null
      paramData.name = ''
      paramData.category_id = null
      paramData.status = ''
      paramData.import_part = ''
      paramData.import_result = null
      paramData.begin_time = null
      paramData.end_time = null
      paramData.page_size = 10
      paramData.page_index = 0
      this.setState({
        paramData,
        opration: true,
        momentDataStart: null,
        momentDataEnd: null
      }, () => {
        this.getTableData()
      })
    }

    // react 卸载
    componentWillUnmount () {
      document.removeEventListener('keydown', this.onKeyup)
    }

    render () {
      return (
        <div className="goodIn">
          <Spin spinning={this.state.spinLoading}>

            <div className="search">
              <section style={{marginTop: '16px'}}>
                <span className={styles.publicspan}>商品名称/编码：</span>
                <Input onKeyDown={this.onKeyup} placeholder='请输入' name='name' value={this.state.paramData.name} onChange={(e) => this.handleChangeInput(e, 'name')} style={{ width: 196, marginRight: '0px' }} />

                <span className={styles.publicspan}>商品类别：</span>
                <Select
                  showSearch
                  onKeyDown={this.onKeyup}
                  style={{ width: 196, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  allowClear
                  value={this.state.paramData.category_id}
                  onChange={(e) => this.handelChangeSource(e, 'category_id')}
                >
                  {(this.state.categoryArr || this.state.categoryArr.length === 0) ? this.state.categoryArr.map((item, index) => (
                    <Option key={index + 1} name='category_id' value={item.old_category_code}>{item.category_name}</Option>
                  )) : null}
                </Select>

                <span className={styles.publicspan}>商品品牌：</span>
                <Select
                  showSearch
                  onKeyDown={this.onKeyup}
                  style={{ width: 196, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={this.state.paramData.brand_id}
                  onChange={(e) => this.handelChangeSource(e, 'brand_id')}
                >
                  <Option key={0} name='brand_id' value=''>请选择</Option>
                  {this.state.brandArr || this.state.brandArr.length === 0 ? this.state.brandArr.map((item, index) => (
                    <Option key={index + 1} name='brand_id' value={item.id}>{item.name}</Option>
                  )) : null}
                </Select>

                <span className={styles.publicspan}>提交时间：</span>
                <span>
                  <DatePicker
                    onOpenChange={this.handleOpenChange}
                    format= 'YYYY-MM-DD'
                    onPanelChange={this.handlePanelChange}
                    onChange={(e) => this.handleChangeDate(e, 'begin_time')}
                    value ={this.state.momentDataStart}
                  />
                  <span style={{margin: '0px 34px'}}>至</span>
                  <DatePicker
                    format= 'YYYY-MM-DD'
                    onOpenChange={this.handleOpenChange}
                    onPanelChange={this.handlePanelChange}
                    onChange={(e) => this.handleChangeDate(e, 'end_time')}
                    value ={this.state.momentDataEnd}
                  />
                </span>

              </section>

              <section style={{marginTop: '24px'}}>
                <span className={styles.publicspan}>引入阶段：</span>
                <Select
                  showSearch
                  onKeyDown={this.onKeyup}
                  style={{ width: 196, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={this.state.paramData.import_part}
                  onChange={(e) => this.handelChangeSource(e, 'import_part')}
                >
                  <Option key={0} name='import_part' value=''>请选择</Option>
                  {(this.state.importPartArr || this.state.importPartArr.length === 0) ? this.state.importPartArr.map((item, index) => (
                    <Option key={index + 1} name='import_part' value={item.value}>{item.name}</Option>
                  )) : null}
                </Select>

                <span className={styles.publicspan}>阶段状态：</span>
                <Select
                  showSearch
                  onKeyDown={this.onKeyup}
                  style={{ width: 196, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={this.state.paramData.status}
                  onChange={(e) => this.handelChangeSource(e, 'status')}
                >
                  <Option key={0} name='status' value=''>请选择</Option>
                  {(this.state.statusArr || this.state.statusArr.length === 0) ? this.state.statusArr.map((item, index) => (
                    <Option key={index + 1} name='status' value={item.value}>{item.name}</Option>
                  )) : null}
                </Select>

                <span className={styles.publicspan}>最终结果：</span>
                <Select
                  showSearch
                  // mode="multiple"
                  style={{ width: 196, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={this.state.paramData.import_result}
                  onChange={(e) => this.handelChangeSource(e, 'import_result')}
                >
                  <Option key={0} name='import_result' value=''>请选择</Option>
                  <Option key={1} name='import_result' value='to_import'>待引入</Option>
                  <Option key={2} name='import_result' value='pass_import'>引入成功</Option>
                  <Option key={3} name='import_result' value='refuse_import'>引入失败</Option>
                </Select>

                <Button type='primary' style={{marginLeft: '28px'}} onKeyDown={this.onKeyup} onClick={this.handleSearch} shape="round">查询</Button>
                <Button type='primary' style={{margin: '0px 8px'}} onClick={this.handleReset} shape="round">重置</Button>
              </section>
            </div>
            <div className="goodBody">
              <section>
                <TableComponent history={this.props.history} opration={this.state.opration} getTableData={this.getTableData} categoryArr ={this.state.categoryArr} tableData = {this.state.tableData}/>
                <div className={styles.page}>
                  <span style={{position: 'absolute', left: '2px', top: '-4px', fontSize: '14px'}}><span>共</span><span>{this.state.total}</span><span>条记录</span></span>
                  <Pagination current={this.state.paramData.page_index * 1 + 1} showQuickJumper total={this.state.total} showSizeChanger onChange={this.pageChage}/>
                </div>
              </section>
            </div>
          </Spin>
        </div>
      )
    }
}
export default CommodityManagementList



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/commoditymanagementlist/commodity-management-list.js